<!-- Modern Clean Login Design -->
<div
  class="min-h-screen flex items-center justify-center bg-gradient-to-br from-lala-blue via-lala-blue-dark to-slate-900 p-5 backpatern bg-gray-200"
>
  <!-- Login Card -->
  <div
    class="login-card bg-white rounded-xl p-10 max-w-xl w-full"
    style="box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2)"
  >
    <!-- Header -->
    <div class="text-center mb-8">
      <div class="mb-6">
        <img
          src="assets/images/lala-logo.png"
          alt="Grupo LALA"
          class="h-16 mx-auto mb-4"
        />
      </div>
      <h1 class="text-3xl font-bold mb-2" style="color: #2b2b2b">
        Agente de políticas
      </h1>
      <p class="text-gray-600">
        {{ statusMessage || "Inicia sesión para continuar" }}
      </p>
    </div>

    <!-- Microsoft Login Button -->
    <div class="mb-6">
      <button
        (click)="loginWithMicrosoft()"
        [disabled]="isLoading"
        class="w-full flex items-center justify-center gap-3 px-6 py-3 rounded-lg font-medium text-white transition-all duration-200 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
        style="background: #2f2f2f"
      >
        <!-- Microsoft Logo -->
        <svg
          *ngIf="!isLoading"
          class="w-5 h-5"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11 0H0V11H11V0Z" fill="#F25022" />
          <path d="M23 0H12V11H23V0Z" fill="#7FBA00" />
          <path d="M11 12H0V23H11V12Z" fill="#00A4EF" />
          <path d="M23 12H12V23H23V12Z" fill="#FFB900" />
        </svg>

        <!-- Loading Spinner -->
        <svg
          *ngIf="isLoading"
          class="animate-spin h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>

        <span>{{
          isLoading ? statusMessage : "Iniciar sesión con Microsoft"
        }}</span>
      </button>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="mb-6">
      <div class="p-4 rounded-lg bg-red-50 border border-red-200">
        <div class="flex items-start gap-3">
          <svg
            class="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <div class="flex-1">
            <p class="text-sm font-medium text-red-800">
              Error de autenticación
            </p>
            <p class="text-sm text-red-700 mt-1">{{ errorMessage }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Info Message -->
    <div class="text-center">
      <p class="text-xs text-gray-500">
        <svg
          class="w-4 h-4 inline-block mr-1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        Utiliza tu cuenta corporativa de Microsoft
      </p>
    </div>

    <!-- Footer -->
    <div class="text-center mt-8 pt-6 border-t border-gray-200">
      <p class="text-xs text-gray-500">
        &copy; 2025 Grupo LALA. Todos los derechos reservados.
      </p>
    </div>
  </div>
</div>
